import { useEffect, useState } from 'react';

import { fetchProgramBehaviors, type ProgramBehavior } from '@/modules/api';

/**
 * Fetches a program's behaviors ("what you'll work on") for the review screens.
 * Display-only program detail — not routing/domain state — so it's a
 * component-scoped fetch rather than rules-engine state. Re-fetches when the
 * program urn changes and aborts the in-flight request on unmount / change.
 */
export function useProgramBehaviors(programUrn: string | undefined): ProgramBehavior[] {
  const [behaviors, setBehaviors] = useState<ProgramBehavior[]>([]);

  useEffect(() => {
    if (!programUrn) {
      setBehaviors([]);
      return;
    }
    const controller = new AbortController();
    fetchProgramBehaviors(programUrn, controller.signal)
      .then(setBehaviors)
      // Behaviors are non-essential; on error just render without the grid.
      .catch(() => {
        if (!controller.signal.aborted) setBehaviors([]);
      });
    return () => controller.abort();
  }, [programUrn]);

  return behaviors;
}
